/**
 * System appearance → html[data-theme].
 * No user override UI yet — always follows prefers-color-scheme.
 */

const MQ = '(prefers-color-scheme: dark)'

export function resolveSystemTheme () {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light'
  return window.matchMedia(MQ).matches ? 'dark' : 'light'
}

export function applyTheme (theme) {
  if (typeof document === 'undefined') return
  const next = theme === 'dark' ? 'dark' : 'light'
  document.documentElement.setAttribute('data-theme', next)
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    meta.setAttribute('content', next === 'dark' ? '#19191A' : '#284664')
  }
}

export function applySystemTheme () {
  applyTheme(resolveSystemTheme())
}

/**
 * Keep data-theme in sync with OS. Returns an unsubscribe fn.
 */
export function watchSystemTheme () {
  applySystemTheme()
  if (typeof window === 'undefined' || !window.matchMedia) {
    return function () {}
  }
  const mql = window.matchMedia(MQ)
  const onChange = function () {
    applySystemTheme()
  }
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', onChange)
    return function () {
      mql.removeEventListener('change', onChange)
    }
  }
  if (typeof mql.addListener === 'function') {
    mql.addListener(onChange)
    return function () {
      mql.removeListener(onChange)
    }
  }
  return function () {}
}
